<template>


<div>
    <b-modal  
    :no-close-on-esc="true"
     :no-close-on-backdrop="true"
      @shown="onShown()"
      :hide-header="true"
      :hide-footer="true"
      content-class="modal-blue"
      id="pre-reg-modal-show"
      size="xl"
      scrollable
      centered>
        <!-- Modal content-->
        <div class="row ">
          <div class="col mb-5 ">
            <h4 class="mb-4">{{$t('registration.preRegSubject')}}</h4>
               <table >
              <tr  v-for="(subject,i) of preRegSubjects">
          
              
             
                <td>{{subject.subject_code}} | {{  helpers.getLocalizedField(subject, 'subject')}}</td>
                <td>{{subject.day}} </td>
                <td>{{subject.Rooms}}</td>
                <td>{{subject.time?.split('.')[0]}}</td>
                <td>{{subject.Lectors}}</td>
                <td v-if="canDelete.length>0 && subject.can_not_deleted==1 && isInCanDelete(subject.subjectID)"> <img style="cursor: pointer;" class="img-fluid"
                          @click="changePreRegSubject(subject.preRegID,subject.subjectID)"
                          src="/static/images/icons/evaluations/recover.png"></td>
            
              
              
            
                    </tr>
            </table> 
      


          </div>
        </div>
        <div class="row">
          <div class="col mt-0 pt-3 mt-sm-5 pt-sm-0 mb-3">
            <button type="button" class="btn btn-light-bold" @click="hideModal()">{{ $t('registration.close') }}</button>
          </div>
        </div>
    </b-modal>
     
  </div>





    </template>

    <script>
    export default{

        data(){

            return{

                preRegSubjects:[],
                canDelete:[]

            }

        },

        mounted(){

                  this.$store.dispatch('pre_registration/whoCanDelete').then(response=>{ 

                     
                  this.canDelete=response.data

            }) 

        },

        
        methods:{
          changePreRegSubject(preRegID,subjectID){
                
                 this.$store.dispatch('pre_registration/setmustChangePreRegSubject',{subjectID,preRegID})

          },

          hideModal() {
            this.$bvModal.hide('pre-reg-modal-show');
            this.$emit('closed');
          },
      isInCanDelete(subjectID) {
        return this.canDelete.some(item => item.subjectID === subjectID);
      },
      onShown(){

        
      this.$store.dispatch('pre_registration/getPreRegisteredSubjectsToShow').then(response=>{

        
                  this.preRegSubjects=response.data

}) 





     


 


      },
     


        }



    }



</script>

<style scoped>
table ,tr,td{
  border: 1px solid white;
  border-collapse: collapse;
  padding: 10px;
}
</style>